//引入接口文档
import req from '@/utils/req.js'

//根据逻辑树的ID查询输入模板
export function queryInputTemplate(params) {
  return req.get(`/admin/decision-node-output-template/DecisionNodeOutputTemplateVO/${params.decisionTreeId}`);
}

//逻辑树的输入模板添加
export function addInputTemplate(params) {
  return req.post("/admin/decision-node-output-template",params);
}

//逻辑树的输入模板删除
export function deleteInputTemplate(params) {
  return req.delete(`/admin/decision-node-output-template/${params.id}`);
}


